import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import ProjectItem from '~components/project-item';
import { Container, Heading, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { NextSeo } from 'next-seo';
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ProjectsPage = function(props) {
    var data = props.data;
    var pageMeta = {
        title: 'Creations and projects',
        description: 'Here are some of my past creations from personal projects and professional works.'
    };
    return(/*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(NextSeo, _objectSpread({}, pageMeta)),
            /*#__PURE__*/ _jsx(Container, {
                maxW: "4xl",
                p: [
                    4,
                    8
                ],
                children: /*#__PURE__*/ _jsxs(Stack, {
                    align: "center",
                    spacing: 4,
                    textAlign: "center",
                    children: [
                        /*#__PURE__*/ _jsx(Heading, {
                            children: pageMeta.title
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            pb: 8,
                            children: pageMeta.description
                        }),
                        /*#__PURE__*/ _jsx(SimpleGrid, {
                            columns: [
                                1,
                                1,
                                2
                            ],
                            gap: 4,
                            children: data.allProjects.map(function(s) {
                                /*#__PURE__*/ return _jsx(ProjectItem, {
                                    data: s
                                }, s.id);
                            })
                        })
                    ]
                })
            })
        ]
    }));
};
export var __N_SSG = true;
export default ProjectsPage;
